import type { EditorSDK } from '@wix/platform-editor-sdk';

import type { EditorReadyOptions } from '../../../../types';
import { shouldAddGlobalController } from '../../../../utils/experiments';
import { getMyAccountInstallDefinition, SOCIAL_APPS_IDS } from '../../../constants';
import { isStandaloneInstallation } from '../../../util';
import { installApps } from '../integration';
import { uninstallMembersArea } from '../services/uninstall';
import {
  monitoredAddGlobalController,
  monitoredAddInitialMenuItemsToMemberMenus,
  monitoredAddLoginMenus,
  monitoredAddMemberSettingsSubMenu,
  monitoredAddProfileSubMenu,
  monitoredInstallMembersBlocksPlatform,
  monitoredNavigateToMemberSettingsPage,
} from './monitored-methods';

const isSocialInstallation = (options: EditorReadyOptions) => {
  const appTriggeredInstall = options.origin.info?.appDefinitionId;
  return appTriggeredInstall ? SOCIAL_APPS_IDS.includes(appTriggeredInstall) : false;
};

export const installMembersArea = async (editorSDK: EditorSDK, options: EditorReadyOptions) => {
  try {
    if (await shouldAddGlobalController()) {
      await monitoredAddGlobalController(editorSDK);
    }
    await Promise.all([
      monitoredAddMemberSettingsSubMenu(editorSDK),
      monitoredAddProfileSubMenu(editorSDK),
      monitoredAddLoginMenus(editorSDK, options),
      monitoredInstallMembersBlocksPlatform(editorSDK, isSocialInstallation(options)),
    ]);

    const isMigrating = options.origin.info?.migrationData?.isMigrating;
    const installMyAccount = isStandaloneInstallation(options) || isMigrating;

    if (installMyAccount) {
      await installApps({ editorSDK, definitions: [getMyAccountInstallDefinition(options.origin)] });
    }

    await monitoredAddInitialMenuItemsToMemberMenus(editorSDK, options);

    if (isStandaloneInstallation(options)) {
      monitoredNavigateToMemberSettingsPage(editorSDK);
    }
  } catch (e) {
    try {
      await uninstallMembersArea(editorSDK);
    } catch (err) {}

    throw e;
  }
};
